import { TaskDto } from '../../../api';
import EditDocumentIcon from '@mui/icons-material/EditDocument';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import VerifiedIcon from '@mui/icons-material/Verified';
import UndoIcon from '@mui/icons-material/Undo';
import CancelIcon from '@mui/icons-material/Cancel';

export const PRODUCT_APPROVAL_RENEWAL_REQUIRED = 'PRODUCT_APPROVAL_RENEWAL_REQUIRED' as const;
export type ExtendedTaskType = TaskDto.type | typeof PRODUCT_APPROVAL_RENEWAL_REQUIRED;

export const getTaskTypes = () => {
    const taskTypes: ExtendedTaskType[] = Object.values(TaskDto.type).filter(
        (type) => type !== TaskDto.type.ANY_ACTION_REQUIRED
    );
    taskTypes.push(PRODUCT_APPROVAL_RENEWAL_REQUIRED);
    return taskTypes;
};

export const getIcon = (taskType: ExtendedTaskType) => {
    switch (taskType) {
        case TaskDto.type.PRODUCT_RELEASE_ENGAGEMENT_ACTION_REQUIRED:
            return EditDocumentIcon;
        case TaskDto.type.PRODUCT_INVOICE_ACTION_REQUIRED:
            return AccountBalanceIcon;
        case TaskDto.type.PRODUCT_FORMULATION_ANNUAL_REPORT_DUE:
            return CalendarTodayIcon;
        case TaskDto.type.PRODUCT_FORMULATION_ANNUAL_REPORT_OVERDUE:
            return EventBusyIcon;
        case TaskDto.type.PRODUCT_CERTIFICATE_ACTION_REQUIRED:
            return VerifiedIcon;
        case TaskDto.type.COMPANY_INVOICE_OPEN:
            return AccountBalanceIcon;
        case TaskDto.type.PRODUCT_APPROVAL_REWORK_NECESSARY:
            return UndoIcon;
        case TaskDto.type.PRODUCT_APPROVAL_REJECTED:
            return CancelIcon;
        case PRODUCT_APPROVAL_RENEWAL_REQUIRED:
            return CalendarTodayIcon;
        default:
            return undefined;
    }
};
/**
 * A mapping of URL filter strings to TaskDto types.
 */
export const TASKS_FILTER_MAP: Record<string, ExtendedTaskType> = {
    'annual-report-overdue': TaskDto.type.PRODUCT_FORMULATION_ANNUAL_REPORT_OVERDUE,
    'annual-report-due': TaskDto.type.PRODUCT_FORMULATION_ANNUAL_REPORT_DUE,
    'invoice-open': TaskDto.type.PRODUCT_INVOICE_ACTION_REQUIRED,
    'company-registration-fee': TaskDto.type.COMPANY_INVOICE_OPEN,
    'release-engagement-signature-required': TaskDto.type.PRODUCT_RELEASE_ENGAGEMENT_ACTION_REQUIRED,
    'certificate-action-required': TaskDto.type.PRODUCT_CERTIFICATE_ACTION_REQUIRED,
    'product-approval-rework-necessary': TaskDto.type.PRODUCT_APPROVAL_REWORK_NECESSARY,
    'product-approval-rejected': TaskDto.type.PRODUCT_APPROVAL_REJECTED,
    'product-approval-renewal-required': PRODUCT_APPROVAL_RENEWAL_REQUIRED,
    'all-tasks': TaskDto.type.ANY_ACTION_REQUIRED,
};

/**
 * A reverse mapping of TaskDto types to URL filter strings.
 */
export const FILTER_REVERSE_MAP: Record<ExtendedTaskType, string> = Object.fromEntries(
    Object.entries(TASKS_FILTER_MAP).map(([key, value]) => [value, key])
) as Record<ExtendedTaskType, string>;
